// Root Reducer

import { combineReducers } from "redux";
import authUserReducer from "./authUser";
import layoutReducer from "./layoutReducers";
import courseReducer from "./HolesReducer";
import statesCitiesReducer from "./statesCitiesReducer";
import apiAccessReducer from "./apiAccessReducer";

export let rootReducer = combineReducers({
  authUser: authUserReducer,
  layout: layoutReducer,
  course: courseReducer,
  citiesStates: statesCitiesReducer,
  // NOTE: only `authUser` is persisted to localStorage (see store/index.js),
  // so nothing in `apiAccess` is written to disk. Keep it that way.
  apiAccess: apiAccessReducer,
});

export default rootReducer;
